module.exports = __webpack_public_path__ + "static/cover.66ab517e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cover.png
// module id = 245
// module chunks = 40172571542291 115786611955454